import { render, staticRenderFns } from "./GraphDetail73.vue?vue&type=template&id=bd877f40&scoped=true"
import script from "./GraphDetail73.vue?vue&type=script&lang=js"
export * from "./GraphDetail73.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd877f40",
  null
  
)

export default component.exports